export default __webpack_public_path__ + "static/media/Telugu_df_1.fcd62198.mp3";